import React, { useState, useEffect } from "react";
import { auth, firestore } from "./firebase";
import { signOut } from "firebase/auth";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import "./Dashboard.css";
import BellIcon from "./assets/bellIcon.svg";
import BellIconn from "./assets/Newcardyx.svg";
import Arroww from "./assets/arroww.svg";
import Green from "./assets/downGreen.svg";
import Redd from "./assets/UpRed.svg";
import Card from "./assets/cardnona.png";
import BlueCard from "./assets/blueCard.png";
import Verifyy from "./assets/verit.png";
import MoneyBag from "./assets/moneybagg.svg";
import MoneyBagg from "./assets/bxs-wallet.svg";
import Moneybank from "./assets/bxs-bank.svg";
import Mone from "./assets/sendmoneyy.svg";
import Giftt from "./assets/giftMe.svg";
import Bills from "./assets/Billss.svg";
import Topam from "./assets/topitt.svg";
import AddIcon from "./assets/SignUpIcon/toadd.svg";
import Wrong from "./assets/Subtractgg.svg";
import TransferModal from "./TransferModal";
import BottomBar from "./BottomBar/BottomBar";

const Dashboard = () => {
  const [userData, setUserData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const [photoURL, setPhotoURL] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          console.log("Authenticated user UID:", user.uid);
          const userDocRef = doc(firestore, "users", user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            console.log("User data found:", userDoc.data());
            const data = userDoc.data();
            setUserData(data);
            setWalletBalance(data.balance || 0);

            // Fetch transactions
            fetchTransactions(user.uid);
          } else {
            console.log("No user data found for UID:", user.uid);
          }
        } else {
          console.log("No authenticated user found");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);


  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const userDocRef = doc(firestore, "users", user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
      
        
            setPhotoURL(data.photoURL || "");
       
            setTransactions(data.transactions || []); // Fetching user transaction history
          }
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  const fetchTransactions = async (userId) => {
    try {
      const transactionsQuery = query(
        collection(firestore, "transactions"),
        where("userId", "==", userId)
      );
      const transactionsSnapshot = await getDocs(transactionsQuery);
      const transactionsList = transactionsSnapshot.docs.map((doc) => ({
        ...doc.data(),
        date: doc.data().date.toDate(),
      }));
      setTransactions(transactionsList);
    } catch (error) {
      console.error("Error fetching transactions: ", error);
    }
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate("/");
  };

  const formatTransactionsData = () => {
    const groupedData = transactions.reduce((acc, transaction) => {
      const date = transaction.date.toLocaleDateString();
      if (!acc[date]) {
        acc[date] = { date, amount: 0 };
      }
      acc[date].amount += transaction.amount;
      return acc;
    }, {});
    const formattedData = Object.values(groupedData);
    console.log("Formatted Transactions Data for Histogram:", formattedData);
    return formattedData;
  };

  const renderTransactionIcon = (type) => {
    if (type === "income") {
      return (
        <div className="transaction-icon-income">
          <img src={Mone} alt="Bell Icon" style={{ width: "50%" }} />
        </div>
      );
    } else if (type === "expense") {
      return (
        <div className="transaction-icon-exp">
          <img src={Bills} alt="Bell Icon" style={{ width: "50%" }} />
        </div>
      );
    }
    return null;
  };

  if (loading) {
    return <div className="loader"></div>;
  }

  if (!userData) {
    return (
      <div>
        <div className="no-data">
          <img src={Wrong} style={{ width: 60 }} alt="wrog" />
          <div className="wrongTecxt">
            <h4 style={{ fontSize: 20 }}>Unable to Reach Your Account</h4>
            <p>
              Please use the login button below to login into your account or
              check your network connectivity
            </p>
          </div>
          <button className="nodatainput" onClick={handleSignOut}>
            Login Here
          </button>
          <div
            style={{ color: "#00000050", width: "90%", textAlign: "center" }}
          >
            ------------------ Or -------------------
          </div>
          <button
            className="nodatainputwhite"
            onClick={() => navigate("/signup")}
          >
            Create Your Account
          </button>
        </div>

        <div className="no-data-bottom">
          {/* <img src={Wrong} style={{width: 60}} alt="wrog" /> */}
          <div className="wrongTecxt">
            <h4 style={{ fontSize: 20 }}>
              At UBS Bank your Security is our priority
            </h4>
            <p>
              If we notice any illegal login or activities on your account we
              will log it out immediately
            </p>
          </div>
        </div>
      </div>
    );
  }

  const { income, expenses } = transactions.reduce(
    (totals, transaction) => {
      if (transaction.type === "income") {
        totals.income += transaction.amount;
      } else if (transaction.type === "expense") {
        totals.expenses += transaction.amount;
      }
      return totals;
    },
    { income: 0, expenses: 0 }
  );

  const wallett = () => {
    navigate("/Wallet");
  };

  const handleTransferFunds = async ({ recipientEmail, amount }) => {
    try {
      const user = auth.currentUser;
      if (!user) {
        console.error("No authenticated user found");
        return;
      }

      // Find the recipient user by email
      const usersCollection = collection(firestore, "users");
      const recipientQuery = query(
        usersCollection,
        where("email", "==", recipientEmail)
      );
      const recipientSnapshot = await getDocs(recipientQuery);

      if (recipientSnapshot.empty) {
        console.error("Recipient not found");
        return;
      }

      const recipientDoc = recipientSnapshot.docs[0];
      const recipientData = recipientDoc.data();

      const senderDocRef = doc(firestore, "users", user.uid);
      await updateDoc(senderDocRef, {
        balance: walletBalance - amount,
      });

      const recipientDocRef = doc(firestore, "users", recipientDoc.id);
      await updateDoc(recipientDocRef, {
        balance: recipientData.balance + parseFloat(amount),
      });

      const transactionsCollection = collection(firestore, "transactions");
      await addDoc(transactionsCollection, {
        userId: user.uid,
        type: "expense",
        amount: parseFloat(amount),
        date: new Date(),
        title: "Transfer to " + recipientEmail,
        description: `Transferred $${amount} to ${recipientEmail}`,
      });
      await addDoc(transactionsCollection, {
        userId: recipientDoc.id,
        type: "income",
        amount: parseFloat(amount),
        date: new Date(),
        title: "Transfer from " + user.email,
        description: `Received $${amount} from ${user.email}`,
      });

      setWalletBalance(walletBalance - parseFloat(amount));
      fetchTransactions(user.uid);
    } catch (error) {
      console.error("Error transferring funds: ", error);
    }
  };

  const transactionsInLast7Days = transactions.filter((transaction) => {
    const now = new Date();
    const sevenDaysAgo = new Date(now);
    sevenDaysAgo.setDate(now.getDate() - 7);
    return transaction.date >= sevenDaysAgo && transaction.date <= now;
  });

  return (
    <div className="dashboard">
      <div className="profile">
        <div className="flexer">
          <img
            src={photoURL}
            alt="Profile"
            className="profile-imagee"
          />
          <div className="flexerr">
            <p className="greet">Good Morning</p>
            <h2 className="namee">
              <a className="namee" href="/profile">
                {userData.username}
              </a>
            </h2>
          </div>
        </div>
        <div
          style={{ backgroundColor: "#ffffff", padding: 9, borderRadius: 15 }}
        >
          <Link to="/recent-activities" className="blue">
            <img src={BellIcon} alt="Bell Icon" style={{ width: 25 }} />
          </Link>
        </div>
      </div>

      {/* <div className="parentDivbalance">
        <div className="BalanceHolder">
          <div className="wallett">
            
            <div className="money">
              <h3 className="WalletBalance">$</h3>
              <h3 className="WalletBalanceBig">
                {parseFloat(walletBalance).toLocaleString()}
              </h3>
            </div>
          </div>
          <div className="ledgerBalance">
            <p>
              Ledger{" "}
              <strong>${parseFloat(walletBalance).toLocaleString()}</strong>
            </p>
            <div className="ledgerBalancebtn">
              <p>My Wallet</p>
              <button onClick={wallett} className="buttonn">
                <img src={Arroww} alt="Arrow Icon" />
              </button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="parentDivbalance">
        <p className="wallet">Available Balance</p>
        <div className="money">
          <h3 className="WalletBalance">$</h3>
          <h3 className="WalletBalanceBig">
            {parseFloat(walletBalance).toLocaleString()}
          </h3>
        </div>
        <div className="bottomCardName">
          <h2 className="namee">
            <a className="nameeee" href="/profile">
              {userData.username}
              <img src={Verifyy} alt="Bell Icon" style={{ width: 15 }} />
            </a>
          </h2>
        </div>
        <div className="ledgerBalancebtnn">
          <p style={{ color: "#ffffff" }}>My Wallet</p>
          <button onClick={wallett} className="buttonn">
            <img src={Arroww} alt="Arrow Icon" />
          </button>
        </div>
        <img
          className="imageHolder"
          src={BellIconn}
          alt="Bell Icon"
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      <div className="underwallet">
        <div className="underWalletIncome">
          <img src={Green} alt="Green Icon" />
          <div className="underText">
            <p>Income</p>
            <p className="diffp">${parseFloat(income).toLocaleString()}</p>
          </div>
        </div>
        <div className="underWalletIncomee">
          <img src={Redd} alt="Red Icon" />
          <div className="underText">
            <p>Expenses</p>
            <p className="diffp">${parseFloat(expenses).toLocaleString()}</p>
          </div>
        </div>
      </div>

      <div className="roundedBTNParent">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 15,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="roundedBTN"
            style={{ backgroundColor: "#CCE6FF80" }}
            onClick={() => setIsModalOpen(true)}
          >
            <img src={Mone} alt="Bell Icon" style={{ width: "80%" }} />
          </button>
          <p>Send</p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 15,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="roundedBTN"
            style={{ backgroundColor: "#EDDAFF80" }}
            onClick={() => setIsModalOpen(true)}
          >
            <img src={Giftt} alt="Bell Icon" style={{ width: "80%" }} />
          </button>

          <p>Gift</p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 15,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="roundedBTN"
            style={{ backgroundColor: "#FFD7D780" }}
          >
            <img src={Bills} alt="Bell Icon" style={{ width: "80%" }} />
          </button>
          <p>Pay Bills</p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 15,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            className="roundedBTN"
            style={{ backgroundColor: "#C9FFD880" }}
          >
            <img src={Topam} alt="Bell Icon" style={{ width: "80%" }} />
          </button>
          <p>Top up</p>
        </div>
      </div>

    

      <div className="investMentBoxx">
        <div className="topupChild">
          <h1>Top up your UBS Account</h1>
          <p>Start enjoying all the functionality of ubs bank</p>
        </div>

        <button className="investMentbtnn">
        <img style={{width: 26,}} src={AddIcon} alt="Red Icon" />

        </button>

      </div>

      <div className="investMentBox">
        <div className="investMentbtn">
        ⚡️
        </div>
        <div className="investBoxText">
          <h1>Start investing now!</h1>
          <p>Protected savings and investment plans</p>
        </div>
      </div>

      <div className="moreSection">
        <p className="lower">Earnings</p>
        <p className="blue">See all</p>
      </div>

      <div className="earningblock">
        <div className="earning">
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 50,
              backgroundColor: "#007bff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
            }}
          >
            <img
              src={MoneyBagg}
              alt="Bell Icon"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="earnn">
            <div style={{ fontSize: 18, fontWeight: "500", color: "#ffffff" }}>
              Fiverr
            </div>
            <div style={{ fontSize: 18, fontWeight: "bold", color: "#ffffff" }}>
              ${expenses}
            </div>
          </div>
        </div>
        <div className="earning" style={{ backgroundColor: "#E6E2E6" }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 50,
              backgroundColor: "#836F81",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
            }}
          >
            <img
              src={MoneyBag}
              alt="Bell Icon"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="earnn">
            <div style={{ fontSize: 18, fontWeight: "500", color: "#836F81" }}>
              Upwork
            </div>
            <div style={{ fontSize: 18, fontWeight: "bold", color: "#836F81" }}>
              ${income}
            </div>
          </div>
        </div>

        <div className="earning" style={{ backgroundColor: "#D9E7E5" }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 50,
              backgroundColor: "#42887C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
            }}
          >
            <img
              src={Moneybank}
              alt="Bell Icon"
              style={{ width: "100%", height: "100%" }}
            />
          </div>
          <div className="earnn">
            <div style={{ fontSize: 18, fontWeight: "500", color: "#42887C" }}>
              Electricity
            </div>
            <div style={{ fontSize: 18, fontWeight: "bold", color: "#42887C" }}>
              ${expenses}
            </div>
          </div>
        </div>
      </div>

      {/* <h3 className="moreSection">Transaction Presentation / Histogram</h3>
      <div className="chart-container">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={formatTransactionsData()}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="amount" fill="#8884d8" />
          </BarChart>
        </ResponsiveContainer>
      </div> */}

      <div className="transactions-container">
        {transactions.length > 0 ? (
          <ul className="transaction-list">
            {transactions.map((transaction, index) => (
              <li key={index} className="transaction-item">
                {renderTransactionIcon(transaction.type)}
                <div className="transaction-details">
                  <div className="transaction-title">{transaction.title}</div>
                  <div className="descriptionNotify">
                    <div className="transaction-description">
                      {transaction.description}
                    </div>
                    <span>{transaction.date.toLocaleDateString()}</span>
                  </div>
                </div>
                <div className="transaction-titlee">
                  ${parseFloat(transaction.amount).toLocaleString()}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>{transactionsInLast7Days.length} Transaction(s) made this week</p>
        )}
      </div>
      <div className="moreSection" style={{ marginBottom: "8%" }}>
        <p className="lower">UBS Cards Wallet</p>
        <Link to="/Create-Transaction" className="blue">
          See all
        </Link>
      </div>
      <div className="earningblockk">
        <div className="trans">
          <img src={Card} alt="Profile" className="card-imagee" />

          <p className="cardName">{userData.username}</p>
        </div>

        <div className="trans">
          <img src={BlueCard} alt="Profile" className="card-imagee" />
          <p className="cardName">{userData.username}</p>
        </div>
      </div>

      <div className="moreSection">
        <p className="lower">Recent Transactions</p>
        <Link to="/Create-Transaction" className="blue">
          See all
        </Link>
      </div>

      <div className="transactions-container">
        {transactions.length > 0 ? (
          <ul className="transaction-list">
            {transactions.map((transaction, index) => (
              <li key={index} className="transaction-item">
                <div className="transaction-icon">
                  {renderTransactionIcon(transaction.type)}
                </div>
                <div className="transaction-details">
                  <div className="transaction-title">{transaction.title}</div>
                  <div>
                    <div className="transaction-description">
                      {transaction.description}
                    </div>
                    <span>{transaction.date.toLocaleDateString()}</span>
                  </div>
                </div>
                <div className="transaction-titlee">
                  ${parseFloat(transaction.amount).toLocaleString()}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>No recent transactions.</p>
        )}
      </div>

      <button className="input" onClick={handleSignOut}>
        Sign Out
      </button>
      <Link
        to="/CreateTransaction"
        className="blue"
        style={{ color: "#ffffff" }}
      >
        See all
      </Link>

      {/* <div className="modalBottomm">

      </div> */}

      <BottomBar />

      <TransferModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleTransferFunds}
      />
    </div>
  );
};

export default Dashboard;
